import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { updateUserFamilyMember, fetchUserFamilyMemberById, fetchUserFamilyById } from "../../../service/UserFamilyApi";
import { useForm } from "react-hook-form";
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Loading, Breadcrumbs } from "../../../components/shared";
import { businessNames, relationShips } from '../../general/DropDownValuesConfig';
import useCheckLoggedin from "../../../utils/useCheckLoggedin";
import { showErrorToast } from "../../../utils/Toasts";
import { getYearOptions } from "../../../utils/Utilities";

function FamilyMemberUpdate() {
  useCheckLoggedin();
  const { id } = useParams();
  const navigate = useNavigate();
  const [familyData, setFamilyData] = useState(null);
  const [familyMemberData, setFamilyMemberData] = useState(null);
  const { register, handleSubmit, formState: { errors, isValid, isSubmitting }, setValue } = useForm({ mode: "all" });
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = useState(null);
  const dateInputRef = useRef(null);
  const [selectedYear, setSelectedYear] = useState("");
  // Fetch family data
  useEffect(() => {
    const fetchFamilyMemberData = async () => {
      try {
        if (id) {
          const data = await fetchUserFamilyMemberById(id);
          setFamilyMemberData(data); // Set the fetched data to state
          const dataFamliy = await fetchUserFamilyById(data.familyMember.familyId); // Await the fetchFamilyById function
          setFamilyData(dataFamliy); // Set the family data in state
          // Pre-populate the form with fetched data when editing
          setValue("firstName", data.familyMember.firstName || "");
          setValue("lastName", data.familyMember.lastName || "");
          setValue("businessName", data.familyMember.businessName || "");
          setValue("dob", data.familyMember.dob || "");
          setValue("mobile", data.familyMember.mobile || "");
          setValue("mobile2", data.familyMember.mobile2 || "");
          setValue("email", data.familyMember.email || "");
          setValue("aadhar", data.familyMember.aadhar || "");
          setValue("parentId", data.familyMember.parentId || data.familyMember.aadhar);
          setValue("relationship", data.familyMember.relationship || "");

        }
      } catch (error) {
        setError("Error fetching family member data");
      }
    };

    fetchFamilyMemberData();

  }, [id, setValue]);
  const handleYearChange = (e) => {
    const year = e.target.value;
    setSelectedYear(year);

    const dateString = `${year}-06-01`;

    // Update both DOM and react-hook-form state
    if (dateInputRef.current) {
      dateInputRef.current.value = dateString;
    }
    setValue("dob", dateString, { shouldValidate: true });
  };
  // Handle form submission (API update)
  const onSubmit = async (data) => {
    if (loading) {
      return;  // Prevent form submission if loading is true
    }
    if (!data.firstName || data.firstName.length < 3) {
      alert("பெயர் சரியாக உள்ளிடப்படவில்லை.");
      return;
    }
    if (data.relationship === "இல்லை" && familyMemberData?.familyMember.relationship !== "இல்லை") {
      showErrorToast("உறவு தேர்ந்தெடுக்கவும்.");
      return;
    }
    setLoading(true);
    try {
      if (
        data.firstName !== familyMemberData.familyMember.firstName ||
        data.lastName !== familyMemberData.familyMember.lastName ||
        data.businessName !== familyMemberData.familyMember.businessName ||
        data.dob !== familyMemberData.familyMember.dob ||
        data.mobile !== familyMemberData.familyMember.mobile ||
        data.mobile2 !== familyMemberData.familyMember.mobile2 ||
        data.email !== familyMemberData.familyMember.email ||
        data.aadhar !== familyMemberData.familyMember.aadhar ||
        data.relationship !== familyMemberData.familyMember.relationship ||
        data.parentId !== familyMemberData.familyMember.parentId
      ) {
        const payload = {
          ...data,
        };
        const success = await updateUserFamilyMember(payload);
        if (success) {
          navigate(`/user/family/member-view/${id}`);
        }
      }
    } catch (error) {
      console.error("Error updating family member:", error);
    } finally {
      setLoading(false);  // Set loading back to false after completion
    }

  };
  if (error) {
    return <div>Error: {error}</div>; // Display error message
  }
  // If data is not available, show loading
  if (!familyMemberData) {
    return (
      <>
        <Navbar />
        <div className="general_parent">
          <div className="general_container">
            <div className="general_body">
              <Breadcrumbs /><br />
              <Loading />
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <Helmet>
        <title>Update Family Member</title>
        <link rel="canonical" href={`/family/member-update`} />
      </Helmet>

      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <Breadcrumbs /><br />
            <h3>குடும்ப உறுப்பினர் விவரங்கள்</h3>
            <br />
            <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
              <input
                type="hidden"
                {...register("id")} // Register the id field
                value={familyMemberData.familyMember.id}  // Set the value to the correct id
              />
              <input
                type="hidden"
                {...register("aadhar")} // Register the id field
                value={familyMemberData.familyMember.aadhar}  // Set the value to the correct id
              />

              <input
                type="hidden"
                {...register("familyId")} // Register the id field
                value={familyMemberData.familyMember.familyId}  // Set the value to the correct id
              />


              <div className="details-card">


                {/* Aadhar Number */}
                <div className="detail-item">
                  <span className="detail-label"><strong>ஆதார் எண் :</strong></span>
                  <span>{(familyMemberData.familyMember.aadhar || "இல்லை").replace(/^TMP/, "")}</span>
                </div>

                {/* First Name */}
                <div className="detail-item">
                  <span className="detail-label">பெயர் (தமிழில் கொடுங்கள்)</span>
                  <div className="auth_element">
                    <input
                      type="text"
                      id="firstName"
                      {...register("firstName", {
                        required: "பெயர் தேவை",
                        pattern: { value: /^[A-Za-z\u0B80-\u0BFF\s.]*$/, message: "எழுத்துக்கள், இடைவெளிகள் மற்றும் '.' மட்டும் அனுமதிக்கப்படும்" },
                        minLength: { value: 2, message: "குறைந்தது 2 எழுத்துகள் வேண்டும்" },
                      })}
                      className="auth_input"
                    />
                  </div>
                  {errors.firstName && <div className="auth_error">❗ {errors.firstName.message}</div>}
                </div>

                {/* Last Name */}
                <div className="detail-item">
                  <span className="detail-label">தந்தை/கணவர் பெயர் (தமிழில் கொடுங்கள்)</span>
                  <div className="auth_element">
                    <input
                      type="text"
                      id="lastName"
                      {...register("lastName", {
                        required: "தந்தை/கணவர் பெயர் தேவை",
                        pattern: { value: /^[A-Za-z\u0B80-\u0BFF\s.]*$/, message: "எழுத்துக்கள், இடைவெளிகள் மற்றும் '.' மட்டும் அனுமதிக்கப்படும்" },
                        minLength: { value: 2, message: "குறைந்தது 2 எழுத்துகள் வேண்டும்" },
                      })}
                      className="auth_input"
                    />
                  </div>
                  {errors.lastName && <div className="auth_error">❗ {errors.lastName.message}</div>}
                </div>




                {/* Optional Business Name Field */}
                <div className="auth_element">
                  <label className="auth_label">வணிக பெயர் (தேவையில்லை)</label>
                  <select
                    id="businessName"
                    {...register("businessName")}
                    className="auth_select"
                    defaultValue={familyMemberData?.familyMember.businessName || ""}
                  >
                    <option value="">--Select Business--</option>
                    {businessNames.map((business) => (
                      <option key={business.value} value={business.value}>
                        {business.label}
                      </option>
                    ))}
                  </select>
                  {errors.businessName && <div className="auth_error">❗ {errors.businessName.message}</div>}
                </div>
                {/* Date of Birth */}
                <div className="auth_element">
                  <label className="auth_label">பிறந்த தேதி</label>

                  <div style={{ display: "flex", gap: "10px" }}>
                    {/* Year dropdown */}
                    <select
                      onChange={handleYearChange}
                      value={selectedYear}
                      className="auth_input"
                    >
                      <option value="">ஆண்டு தேர்வு செய்யவும்</option>
                      {getYearOptions(1940).map((year) => (
                        <option key={year} value={year}>{year}</option>
                      ))}
                    </select>

                    {/* Actual date input */}
                    <input
                      type="date"
                      id="dob"
                      ref={dateInputRef}
                      {...register("dob", {
                        required: "பிறந்த தேதி தேவை",
                      })}
                      className="auth_input"
                    />
                  </div>

                  {errors.dob && (
                    <div className="auth_error">❗ {errors.dob.message}</div>
                  )}
                </div>

                {/* Mobile Numbers */}
                <div className="auth_element">
                  <label className="auth_label">கைபேசி எண் (தேவையில்லை)</label>
                  {familyMemberData?.familyMember.relationship === "இல்லை" ? (
                    <div className="detail-item">
                      <span className="detail-value">{familyMemberData.familyMember.mobile || "இல்லை"}</span>
                    </div>
                  ) : (
                    <input
                      type="tel"
                      id="mobile"
                      {...register("mobile", {
                        pattern: {
                          value: /^\d{10}$/,
                          message: "சரியான கைபேசி எண்ணை உள்ளிடவும்",
                        },
                      })}
                      className="auth_input"
                      placeholder="+91-1234567890"
                      autoComplete="off"
                      inputMode="numeric"
                      maxLength="10"
                    />
                  )}
                  {errors.mobile && <div className="auth_error">❗ {errors.mobile.message}</div>}
                </div>


                <div className="auth_element">
                  <label className="auth_label">கைபேசி எண் 2 (தேவையில்லை)</label>
                  <input
                    type="tel"
                    id="mobile2"
                    {...register("mobile2", {
                      pattern: {
                        value: /^\+91[-]?\d{3}[-]?\d{3}[-]?\d{4}$|^(?:\+?\d{1,3})?[-.\s]?(\(?\d{2,3}\)?)?[-.\s]?\d{3}[-.\s]?\d{4}$/,
                        message: "சரியான கைபேசி எண்ணை உள்ளிடவும்",
                      },
                    })}
                    className="auth_input"
                    placeholder="+91-1234567890"
                    autoComplete="off"
                    inputMode="numeric"
                  />
                  {errors.mobile2 && <div className="auth_error">❗ {errors.mobile2.message}</div>}
                </div>

                {/* Email */}
                <div className="auth_element">
                  <label className="auth_label">மின்னஞ்சல் (தேவையில்லை)</label>
                  {familyMemberData?.familyMember.relationship === "இல்லை" ? (
                    <div className="detail-item">
                      <span className="detail-value">{familyMemberData.familyMember.email || "இல்லை"}</span>
                    </div>
                  ) : (
                    <input
                      type="email"
                      id="email"
                      {...register("email", {
                        pattern: {
                          value: /^[a-zA-Z0-9._%+-]+(?:[a-zA-Z0-9-]*[a-zA-Z0-9]+)*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                          message: "மின்னஞ்சல் செல்லுபடியாகாது",
                        },
                      })}
                      className="auth_input"
                      placeholder="ponnachiamman@gmail.com"
                    />
                  )}
                  {errors.email && <div className="auth_error">❗ {errors.email.message}</div>}
                </div>

                {/* Relationship */}
                <div className="auth_element">
                  <label className="auth_label">குடும்ப உறவு</label>
                  {familyMemberData?.familyMember.relationship === "இல்லை" ? (
                    <div className="detail-item">
                      <span className="detail-value">குடும்பத் தலைவர்</span>
                    </div>
                  ) : (
                    <select
                      id="relationship"
                      {...register("relationship", { required: "உறவு தேர்ந்தெடுக்கவும்" })}
                      className="auth_select"
                      defaultValue={familyMemberData?.familyMember.relationship || ""}
                    >
                      <option value="">--Select Relationship--</option>
                      {relationShips.map((relation) => (
                        <option key={relation.value} value={relation.value}>
                          {relation.label}
                        </option>
                      ))}
                    </select>
                  )}
                  {errors.relationship && <div className="auth_error">❗ {errors.relationship.message}</div>}
                </div>

                {/* Parent ID */}
                <div className="auth_element">
                  <label className="auth_label">உறவினரர்</label>
                  {familyMemberData?.familyMember.relationship === "இல்லை" ? (
                    <div className="detail-item">
                      <span className="detail-value">குடும்பத் தலைவர்</span>
                    </div>
                  ) : (
                    <select
                      id="parentId"
                      {...register("parentId", { required: "உறவினரர் தேர்ந்தெடுக்கவும்" })}
                      className="auth_select"
                      defaultValue={familyMemberData?.familyMember.parentId || ""}
                    >
                      <option value="">--Select Parent ID--</option>
                      {familyData?.family?.familyMembers
                        .filter((member) => /^\d{12}$/.test(member.aadhar))
                        .map((member) => (
                          <option key={member.aadhar} value={member.aadhar}>
                            {member.firstName} {member.lastName} ({member.aadhar})
                          </option>
                        ))}
                    </select>
                  )}
                  {errors.parentId && <div className="auth_error">❗ {errors.parentId.message}</div>}
                </div>


                <button type="submit" disabled={!isValid || isSubmitting}
                  className={`auth_submit ${!isValid || isSubmitting ? "disabled_btn" : ""}`}
                >
                  {loading ? 'சமர்ப்பிக்கிறது...' : 'சமர்ப்பிக்கவும்'}
                </button>
                <br />
              </div>
            </form>

            <br />
            <button onClick={() => navigate(`/user/family/view/${familyMemberData.familyMember.familyId}`)}>குடும்ப விவரங்கள்</button>
            <br />
            <button onClick={() => navigate("/user/profile")}>என் கணக்கிற்குச் செல்</button>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default FamilyMemberUpdate;
